export default __webpack_public_path__ + "balsamiq.26a588f6.png";